import { motion } from 'framer-motion';
import { IconDownload } from '@/components/Icons';
import sixteen from '@/assets/images/22.jpeg';

import { BaseAttachment } from '@/components/BaseAttachment';

export default function Attachments({
  name,
  control,
  errors,
  onSubmit,
  form,
  register,
  index,
  disabled
}) {
  return (
    // prettier-ignore
    <motion.form
      initial={{ opacity: 0, y: 10 }}
      exit={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      onSubmit={onSubmit}
      className="flex-1 flex flex-col gap-6">
      <div className=" col-span-2 gap-2">
        <div className="bg-white p-10 rounded-2xl border">
          <h1 className="text-center text-slate-600 font-bold text-lg mb-6">الخطة التسويقية</h1>
          <p className="  py-4 text-slate-500">يكون مخطط العمولات 20% من سعر الاشتراك</p>
          <p className="  py-4 text-xs text-slate-700">مثال توضيحي لعملية الاحتساب</p>
          <img className="h-28 m-auto opacity-70" src={sixteen} alt="" />

          <div
            onClick={() => {
              if (disabled) return;
              const link = document.createElement('a');
              link.href = `/assets/files/MarketingPlan.xlsx`;
              link.setAttribute('download', 'نموذج الخطة التسويقية');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
            className={`flex justify-between px-5  bg-slate-200 rounded-xl ${disabled ? "cursor-not-allowed " : "hover:bg-slate-300"} cursor-pointer  text-slate-600  fill-slate-600  py-3  items-center `}>
            <p> نموذج الخطة التسويقية </p>
            <span className="mx-3 fill-slate-500">
              <IconDownload />
            </span>
          </div>
          <div className="my-5">
            <BaseAttachment
              disabled={disabled}
              control={control}
              placeholder="الخطة التسويقية"
              name={`${name}.MarketingPlan`}
              error={errors.areaList && errors.areaList[index]?.MarketingPlan}
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              label="الخطة التسويقية"
              required
              defaultValue={form[`${name}.MarketingPlan`]}
            />
          </div>
        </div>
      </div>

      <div className=" col-span-2 gap-2">
        <div className="bg-white p-10 rounded-2xl border">
          <h1 className="text-center font-bold text-lg mb-6">الخطة التنفيذية </h1>
          <p className=" text-slate-400 my-4">
            يرجى التفضل بالاطلاع على شروط الخطة التنفيذية المرفقة بالرابط ادناه
          </p>
          <div
            onClick={() => {
              if (disabled) return;
              const link = document.createElement('a');
              link.href = `/assets/files/TermsandConditionsDeploymentPlan.docx`;
              link.setAttribute('download', 'شروط واحكام الخطة التنفيذية');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
            className={`flex justify-between px-5  bg-slate-200 rounded-xl ${disabled ? "cursor-not-allowed " : "hover:bg-slate-300"} cursor-pointer  text-slate-600  fill-slate-600  py-3  items-center `}>            <p>شروط واحكام الخطة التنفيذية </p>
            <span className="mx-3 fill-slate-500">
              <IconDownload />
            </span>
          </div>
          <div className="flex flex-wrap items-center my-4 ">
            <input
              id="default-checkbox"
              type="checkbox"
              disabled={disabled}
              name={`${name}.DeploymentPlanBolean`}
              {...register(`${name}.DeploymentPlanBolean`)}
              className="w-4 h-4 text-blue-600  cursor-pointer bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            />
            <label
              htmlFor="default-checkbox"
              className="mx-2 flex-1 text-sm cursor-pointer font-medium text-gray-700 ">
              {'اوافق على شروط واحكام الخطة التنفيذية  '}
            </label>
          </div>
          {errors.areaList && errors.areaList[index]?.DeploymentPlanBolean && (
            <p className="text-xs text-red-400 mt-2 ">
              {errors.areaList[index]?.DeploymentPlanBolean?.message}
            </p>
          )}
          <div
            onClick={() => {
              if (disabled) return;
              const link = document.createElement('a');
              link.href = `/assets/files/DeploymentPlan.xlsx`;
              link.setAttribute('download', 'نموذج الخطة التنفيذية');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
            className={`flex justify-between px-5  bg-slate-200 rounded-xl ${disabled ? "cursor-not-allowed " : "hover:bg-slate-300"} cursor-pointer  text-slate-600  fill-slate-600  py-3  items-center `}>            <p>شروط واحكام الخطة التنفيذية </p>
            <p> نموذج الخطة التنفيذية </p>
            <span className="mx-3 fill-slate-500">
              <IconDownload />
            </span>
          </div>
          <div className="my-5">
            <BaseAttachment
              disabled={disabled}
              control={control}
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              name={`${name}.DeploymentPlan`}
              required
              error={errors.areaList && errors.areaList[index]?.DeploymentPlan}
              label="الخطة التنفيذية "
              defaultValue={form[`${name}.DeploymentPlan`]}
            />
          </div>
        </div>
      </div>

      <div className=" col-span-2 gap-2">
        <div className="bg-white p-10 rounded-2xl border">
          <h1 className="text-center text-slate-600 font-bold text-lg mb-6">خطة الصيانة</h1>
          <div
            onClick={() => {
              const link = document.createElement('a');
              link.href = `/assets/files/MaintenancePlan.xlsx`;
              link.setAttribute('download', 'نموذج خطة الصيانة');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
            className="flex justify-between px-5  bg-slate-200 rounded-xl cursor-pointer hover:bg-slate-300 text-slate-600  fill-slate-600  py-3  items-center ">
            <p>نموذج خطة الصيانة </p>
            <span className="mx-3 fill-slate-500">
              <IconDownload />
            </span>
          </div>
          <div className="my-5">
            <BaseAttachment
              disabled={disabled}
              control={control}
              placeholder="خطة الصيانة"
              name={`${name}.MaintenancePlan`}
              error={errors.areaList && errors.areaList[index]?.MaintenancePlan}
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              label="خطة الصيانة"
              required
              defaultValue={form[`${name}.MaintenancePlan`]}
            />
          </div>
        </div>
      </div>
    </motion.form>
  );
}
